import { Popover, Button } from "@patternfly/react-core";
import { OutlinedQuestionCircleIcon } from '@patternfly/react-icons';
import { ReactNode } from "react";

interface HelpPopoverProps {
    /** Header text or content for the popover */
    headerContent: ReactNode,
    /** Body content for the popover */
    bodyContent: ReactNode,
    /** Optional element to append the popover to. If not provided, uses default positioning. */
    appendTo?: HTMLElement | HTMLDivElement | ((ref?: HTMLElement) => HTMLElement) | "inline" | undefined | null,
    /** If true, uses the 'control' button variant with 'appended-field-button' class */
    useAppendedStyle?: boolean,
    /** Optional additional class name for the button */
    className?: string,
}

/** A generic help popover component that displays a question mark icon that shows
 * a popover with help content when clicked.
 */
const HelpPopover = ({ headerContent, bodyContent, appendTo, useAppendedStyle, className }: HelpPopoverProps) => {
    return (
        <Popover
            headerContent={headerContent}
            bodyContent={bodyContent}
            appendTo={appendTo || undefined}
            withFocusTrap={true}
        >
            {useAppendedStyle ? (
                <Button variant="control" className={`appended-field-button ${className || ''}`}><OutlinedQuestionCircleIcon /></Button>
            ) : (
                <Button variant="plain" className={className}><OutlinedQuestionCircleIcon /></Button>
            )}
        </Popover>
    );
}

export default HelpPopover;
